import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import styled from "@emotion/styled";

interface Props {
  text: string;
  details: string;
  sx?: any;
  onClick: Function;
  children: JSX.Element;
}

const Quotebox = ({
  text,
  children,
  details,
  sx,
  onClick,
}: Props): JSX.Element => {
  const theme = useTheme();

  const GridStyled = styled(Grid)`
    cursor: pointer;
    border-radius: 20px;
    background: radial-gradient(
      94.81% 574.6% at 18.65% 100%,
      #ffffff 0%,
      #e7ebf0 100%
    );
    backdrop-filter: blur(47.5px);
    padding: 20px;
    height: 92px;

    &:hover {
      box-shadow: 0 5px 7px rgb(11 33 63 / 40%);
    }

    & .MuiChip-root {
      transition-property: color, background-color, box-shadow, border;
      transition-duration: 0.2s, 0.2s;
    }

    &:hover .MuiChip-root {
      color: white;
      background-color: ${theme.palette.primary.main}!important;
    }

    &:hover .quote-box-text {
      font-weight: 700;
      color: black;
    }

    transition-delay: 0s, 0s;
    transition-duration: 0.2s, 0.2s;
    transition-property: font-weight, color, background-color, box-shadow,
      border;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1),
      cubic-bezier(0.4, 0, 0.2, 1);
  `;

  return (
    <GridStyled item lg={3} md={7} sx={sx} onClick={() => onClick()}>
      <Box sx={{ display: "flex", gap: "8px" }}>
        <Box>{children}</Box>
        <Box
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"space-between"}
          gap={"14px"}
        >
          <Typography
            fontSize="16px"
            color="#212121"
            fontWeight={500}
            lineHeight={1}
            className="quote-box-text"
          >
            {text}
          </Typography>

          <Typography fontSize="16px" color="#666666" lineHeight={1}>
            {details}
          </Typography>
        </Box>
      </Box>
    </GridStyled>
  );
};

export default Quotebox;
